import React, {useEffect, useState} from 'react';
import _ from 'lodash';
import Money from "../../../lib/Money";
import {agentFieldClassName, formatCentsPrice} from "../utility/cartHelpers";

/**
 * 2025-05 heavily refactored and simplified.
 *
 * @param item
 * @param agentUnitPrice
 * @param updateUnitPrice
 * @param handleBlur
 * @param shoppingCart
 * @param violated
 * @returns {JSX.Element}
 * @constructor
 */
export default function AgentUnitPriceField({
  item,
  agentUnitPrice,
  updateUnitPrice,
  commitChanges,
  violated = false,
  readOnly = false
}) {
  const [focused, setFocused] = useState(false);

  const [displayValue, setDisplayValue] = useState(
    () => formatCentsPrice(agentUnitPrice));

  useEffect(() => {
    setDisplayValue(formatCentsPrice(agentUnitPrice));
  }, [agentUnitPrice])

  function handleInput(evt) {
    let newVal = evt.target.value;  // string, may have '.'

    if (_.isEmpty(newVal) || (+newVal < 0.01)) { //  was: or (newVal === "0")
      updateUnitPrice(null);
    } else {
      let dollars = Money.fromDollars(+newVal);
      updateUnitPrice(dollars.value()); // cents
    }
    setDisplayValue(newVal);
  }

  function handleBlur() {
    setFocused(false);
    commitChanges();
  }

  const className = agentFieldClassName({violated, focused});

  let valueAttrs = focused ? {defaultValue: displayValue || ''} : {value: displayValue};

  return <div>
    <input
      type="numeric" min="0.01"
      className={className}
      placeholder="$ each"
      {...valueAttrs}
      onInput={handleInput}
      onFocus={() => setFocused(true)}
      onBlur={handleBlur}
      readOnly={readOnly || false}
    /></div>
}


